import React, {
    FunctionComponent,
    useCallback,
    useRef,
    useEffect,
  } from "react";
  import styles from "./UserDetails.module.css";
  import { auth, firestore } from "../../../Firebase";
  import { FaUserCircle } from "react-icons/fa";
  import { connect } from "react-redux";
  import { useHistory } from "react-router";
  import Dialog from "@material-ui/core/Dialog";
  import DialogActions from "@material-ui/core/DialogActions";
  import DialogContent from "@material-ui/core/DialogContent";
  import DialogContentText from "@material-ui/core/DialogContentText";
  import DialogTitle from "@material-ui/core/DialogTitle";
  import Slide from "@material-ui/core/Slide";
  import { TransitionProps } from "@material-ui/core/transitions";
  import Button from "@material-ui/core/Button";
  import {themeColors} from "../../theme";
  import { v4 as uuidv4 } from 'uuid';

  type props = {
    openModal: boolean;
    setOpenLogoutModal: any;
    contacts: {
      data: any;
    };
    theme:any;
    user: any;
  };
  
  const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  
  const UserDetails: FunctionComponent<props> = ({
    openModal,
    setOpenLogoutModal,
    contacts,
    theme,
    user
  }) => {
    const history = useHistory();
  
    // const logOut = async () => {
    //   localStorage.removeItem("web_device_id");
    //   Object.keys(contacts.data).forEach((key) => {
    //     contacts.data[key] = [];
    //   });
    //   await auth.signOut();
    //   history.replace("/", {});
    // };

    // const monitorSession= (userId:any, sessionToken:any,setOpenLogoutModal: any)=> {
    //   const userDocRef = firestore.collection('users').doc(userId);
    
    //   userDocRef.onSnapshot((doc) => {
    //     const userData:any= doc.data();
    //     if (userData.sessionToken !== sessionToken) {
    //       // Invalidate current session
    //       // setOpenLogoutModal(true);
    //       // alert('You have been signed out because your account was accessed from another device.');
    //       // signOut();
    //       return;
         
    //     }
    //   });
    
    // }

    function generateSessionToken() {
      return uuidv4();
    }
    const logInToNewDevice = async(uid: any) => {
      const sessionToken = generateSessionToken();

       const userDocRef = firestore.collection('users').doc(uid);
       await userDocRef.set({
         sessionToken: sessionToken,
         isLoggedIn: true
       }, { merge: true });

       const doc = await userDocRef.get();
       if (doc.exists) {
       } else {
         console.error('No such document!');
       }

       localStorage.setItem('sessionToken', sessionToken);
       
       window.location.reload();

      //  monitorSession(uid, sessionToken,setOpenLogoutModal);

    }

    const signOut=async()=> {
      const user = auth.currentUser;
      if (user) {
        await firestore.collection('users').doc(user.uid).set({
          isLoggedIn: false,
          sessionToken: ''
        }, { merge: true });
    
        localStorage.removeItem('sessionToken');
        await auth.signOut();
      }
    }
  
    // const handleClose = () => {
    //   setOpen(false);
    // };
  
    const containerStyles = {backgroundColor:theme ? themeColors.navbarBackgroundColor:themeColors.navbarBackgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}

    return (
      <>
          <Dialog
          open={openModal}
          TransitionComponent={Transition}
          keepMounted
          // onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" style={containerStyles}>
            {"Confirmation"}
          </DialogTitle>
          <DialogContent  style={containerStyles}>
            <DialogContentText id="alert-dialog-slide-description" style={containerStyles}>
            User is logged in another device, 
            If you login here it will logout from that device
            </DialogContentText>
          </DialogContent>
          <DialogActions  style={containerStyles}>
            <Button onClick={signOut} color="secondary">
              Stay Logged In There
            </Button>
            <Button onClick={()=>{
              logInToNewDevice(user.uid);
            }} color="primary">
              Log In Here
            </Button>
          </DialogActions>
        </Dialog>  
      </>
    );
  };
  
  const mapStateToProps = (state: any) => {
    return {
      user: state.user.data,
      contacts: state.contacts,
      theme: state.theme.isLightMode,
    };
  };
  
  export default connect(mapStateToProps)(UserDetails);
  